import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=a3b57f7e&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b57f7e",
  null
  
)

export default component.exports